<!-- First the colour ORb/Badge-->
@if (displayStatusOrb) {
  <app-badge-status-display [badgeStatus]="statusAsBadgeStatus"></app-badge-status-display>
}
<!-- The Status translated for user readability -->
@if (displayStatusString) {
  <span translate="{{statusAsTranslationKey}}"></span>
}